import React from 'react';
import { X } from 'lucide-react';

export type ReservationFormHeaderProps = {
  isEditing: boolean;
  onClose: () => void;
};

export default function ReservationFormHeader({
  isEditing,
  onClose,
}: ReservationFormHeaderProps) {
  return (
    <div className="form-header">
      <h3>{isEditing ? 'Editar Reserva' : 'Nova Reserva'}</h3>
      <button className="close-btn" onClick={onClose} type="button">
        <X size={18} />
      </button>
    </div>
  );
}
